export function removeEntities(entities, field, values) {
    if (values === undefined) {
        return entities;
    }

    const idsToRemove = entities.valueSeq()
        .filter(m => values.indexOf(m.get(field)) !== -1)
        .map(m => m.get('id'))
        .toArray();

    entities = entities.withMutations(e => {
        for (let j = 0; j < idsToRemove.length; j++) {
            const id = idsToRemove[j];
            e.delete(id);
        }
    });

    return entities;
}

export function myRemoveEntities(entities, field, values) {
    if (values === undefined) {
        return entities;
    }

    if (entities.size <= 0) {
        return entities;
    }

    const idsToRemove = values.map(v => v.id);

    entities = entities.filter(e => {
        const fieldValue = Number(e.get(field));

        return (idsToRemove.indexOf(fieldValue) == -1);
    });

    return entities;
}

export function myRemoveEntitiesBySport(entities, field, values) {
    if (values === undefined) {
        return entities;
    }

    if (entities.size <= 0) {
        return entities;
    }

    entities = entities.filter(e => {
        const fieldValue = Number(e.get(field));

        return (values.indexOf(fieldValue) == -1);
    });

    return entities;
}


// WEBPACK FOOTER //
// ./js/shared/reducers/entities/utils.js